export const QUESTION_ANSWER = [
    [
        {
            question: `Does the platform make booking a business trip easy?`,
            answer: `It is as simple as using your favourite banking app. We have provided everything in one simple dashboard. Book your trips and automate reconciliation easily.`
        },
        {
            question: `Do you have a large inventory?`,
            answer: `It’s the largest inventory you can find for all your needs. Does not matter if your request is international or local, we have combined all the available GDS for you to choose your preferred option on flights, hotels and car services.`
        },
        {
            question: `Can I set a travel policy for my organization?`,
            answer: `Yes, you can set a policy to guide your bookings 
and budget. This can also be automated in your 
simple dashboard so you can easily select the 
option that fit the different traveling staff.`
        },
    ],
    [
        {
            question: `What are the benefit of using your hotel booking service?`,
            answer: `You won't find any other corporate discounts 
like ours anywhere else, saving you money. 
Organizing conferences and retreats will be a
hassle-free process with Kardinal group 
bookings.
`
        },
        {
            question: `Can your platform acoomdoate using group bookings for hotels ?`,
            answer: `Sure. Bookings for groups are available in addition to our regular bookings. Our travel consultant will work with you and ensure your travel arrangements and accommodation, as well as group discounts, can be arranged.`
        },
        {
            question: "Can i set a policy also for hotel booking ?",
            answer: `Yes, you can set a policy to guide your hotel 
bookings and budget across different strata for 
staff. This can also be automated in your simple 
dashboard so you can easily select the option 
that fit the different travelling staff.`
        }
    ],
    [
        {
            question: `Does the platform make booking a business trip easy?`,
            answer: `Kardinal's duty of care, K- Care, is our way of 
supporting businesses by providing morally and 
legally safe working environments for their 
employees especially on business trips. 
Business travellers’ duty of care involves 
providing extensive information on the safety, 
regulatory and country related tips ensuring 
their safety and well being while on a trip`
        },
        {
            question: `Do you have a large inventory?`,
            answer: `It is a proactive and responsible way to travel. 
K-Care provides businesses a wide range of 
travel solutions. This solution will help you as a 
business to understand the risks and risks that 
are associated with a particular trip before 
embarking on a journey. With this solution your 
organization will be able to take advantage of 
uncertain times by adapting and responding 
quickly.`
        },
        {
            question: `Can I set a travel policy for my organization?`,
            answer: `Yes, Kcare is a free add-on for every registered 
business on our platform. They can choose from 
a wide range of communication including
automated alerts, dedicated personnel supports 
etc.`
        },
        {
            question: `Can your platform accomodate group bookings?`,
            answer: `K-Care is only available when you sign up`
        },
    ],
    [
        {
            question: `What is k-care?`,
            answer: `Kardinal's duty of care, K-Care, is our way of 
supporting businesses by providing morally and 
legally safe working environments for their 
employees especially on business trips. 
Business travellers’ duty of care involves 
providing extensive information on the safety, 
regulatory and country related tips ensuring 
their safety and well being while on a trip`
        },
        {
            question: `How does it work?`,
            answer: `It is a proactive and responsible way to travel. 
K-Care provides businesses a wide range of 
travel solutions. This solution will help you as a 
business to understand the risks and risks that 
are associated with a particular trip before 
embarking on a journey. With this solution your 
organization will be able to take advantage of 
uncertain times by adapting and responding 
quickly.`
        },
        {
            question: `Is k-care a free service?`,
            answer: `Yes, K-care is a free add-on for every registered 
business on our platform. They can choose from 
a wide range of communication including
automated alerts, dedicated personnel supports 
etc.`
        },
        {
            question: `What are the available service for K - Care?`,
            answer: `K-Care is only available when you sign up`
        }

    ]
];

export const QUESTION_ANSWER_HOTEL = [
    {
        question: `What are the benefit of using your hotel booking service?`,
        answer: `You won't find any other corporate discounts 
like ours anywhere else, saving you money. 
Organizing conferences and retreats will be a
hassle-free process with Kardinal group 
bookings.
`
    },
    {
        question: `Can your platform acoomdoate using  group bookings for hotels?`,
        answer: `Sure. Bookings for groups are available in addition to our regular bookings. Our travel consultant will work with you and ensure your travel arrangements and accommodation, as well as group discounts, can be arranged.`
    },
    {
        question: `Can i set a policy also for hotel booking?`,
        answer: `Yes, you can set a policy to guide your hotel 
bookings and budget across different strata for 
staff. This can also be automated in your simple 
dashboard so you can easily select the option 
that fit the different travelling staff.`
    },
];

export const QUESTION_ANSWER_TRAVEL = [
    {
        question: `Does the platform make booking a business trip easy?`,
        answer: `Kardinal's duty of care, K- Care, is our way of supporting businesses by providing morally and legally safe working environments for their employees especially on business trips. Business travellers’ duty of care involves providing extensive information on the safety, regulatory and country related tips ensuring their safety and well being while on a trip`
    },
    {
        question: `Do you have a large inventory?`,
        answer: `It is a proactive and responsible way to travel. 
K-Care provides businesses a wide range of 
travel solutions. This solution will help you as a 
business to understand the risks and risks that 
are associated with a particular trip before 
embarking on a journey. With this solution your 
organization will be able to take advantage of 
uncertain times by adapting and responding 
quickly.`
    },
    {
        question: `Do you have a large inventory?`,
        answer: `Yes, Kcare is a free add-on for every registered 
business on our platform. They can choose from 
a wide range of communication including
automated alerts, dedicated personnel supports 
etc.`
    },
    {
        question: `Can your platform accomodate group bookings?`,
        answer: `K-Care is only available when you sign up`
    },

];
